import type { ReactNode } from "react";
import { Box } from "@mui/material";

interface AppBarLogoProps {
	readonly children: ReactNode;
}

export const AppBarLogo = ({ children }: AppBarLogoProps) => (
	<Box
		data-testid="app-bar-logo"
		sx={{
			display: "flex",
			alignItems: "center",
			width: "max-content",
			height: 32,
			maxWidth: 245,
			flexShrink: 0,
			overflow: "hidden",
			"& > img, & > svg": {
				display: "block",
				flexShrink: 0,
				height: 32,
				width: "auto",
			},
		}}
	>
		{children}
	</Box>
);
